(function () {
  'use strict';

  function publish(name, data) {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, data || {});
    }
  }

  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function numericUnit(label) {
    var normalized = String(label || '').toLowerCase().replace(/,/g, '').trim();
    if (normalized.indexOf('kg') !== -1) return parseFloat(normalized) * 1000;
    var match = normalized.match(/[\d.]+/);
    return match ? parseFloat(match[0]) : 1;
  }

  function selectedOption(variant, names) {
    var options = variant.options || [];
    var optionNames = names || [];
    var result = {};
    optionNames.forEach(function (name, index) { result[name] = options[index]; });
    return result;
  }

  function sourceData(root) {
    try {
      var variants = JSON.parse(root.querySelector('[data-kp-variant-json]').textContent);
      var names = JSON.parse(root.querySelector('[data-kp-option-json]').textContent);
      return { variants: variants, optionNames: names };
    } catch (error) {
      return { variants: [], optionNames: [] };
    }
  }

  function crossoverData(root) {
    try {
      var variants = JSON.parse(root.querySelector('[data-kp-crossover-variant-json]').textContent);
      var names = JSON.parse(root.querySelector('[data-kp-crossover-option-json]').textContent);
      return { variants: variants, optionNames: names };
    } catch (error) {
      return { variants: [], optionNames: [] };
    }
  }

  function tierData(root, data, activeVariant) {
    var current = selectedOption(activeVariant, data.optionNames);
    var isTablet = data.optionNames.indexOf('Quantity') !== -1;
    var unitOption = isTablet ? 'Quantity' : 'Size';
    var groupOptions = data.optionNames.filter(function (name) { return name !== unitOption; });
    var dedupe = {};

    data.variants.forEach(function (variant) {
      var options = selectedOption(variant, data.optionNames);
      var matchesSelectedConfiguration = groupOptions.every(function (name) {
        return options[name] === current[name];
      });
      if (!matchesSelectedConfiguration) return;
      var unitLabel = options[unitOption];
      if (!unitLabel || dedupe[unitLabel]) return;
      var units = numericUnit(unitLabel);
      dedupe[unitLabel] = {
        id: String(variant.id),
        label: unitLabel,
        units: units,
        price: Number(variant.price),
        unitPrice: Number(variant.price) / units
      };
    });

    var tiers = Object.keys(dedupe).map(function (key) { return dedupe[key]; });
    tiers.sort(function (a, b) { return a.units - b.units; });
    var baseline = tiers[0] ? tiers[0].unitPrice : 0;
    tiers.forEach(function (tier) {
      tier.savings = baseline > 0 ? Math.max(0, (1 - tier.unitPrice / baseline) * 100) : 0;
    });
    return { tiers: tiers, isTablet: isTablet, current: current, baseline: baseline };
  }

  function findActiveVariant(root, variants) {
    var initialId = String(root.getAttribute('data-initial-variant') || '');
    return variants.find(function (variant) {
      return String(variant.id) === initialId;
    }) || variants[0];
  }

  function updateQuoteLinks(productHandle, variant) {
    document.querySelectorAll('[data-kp-bulk-quote-link]').forEach(function (link) {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('product', productHandle);
      if (variant) url.searchParams.set('variant', String(variant.id));
      if (!url.searchParams.get('source')) url.searchParams.set('source', 'bulk-product');
      link.setAttribute('href', url.pathname + url.search);
    });
  }

  function renderCrossover(root, currentUnits, unitName, currency) {
    var container = root.querySelector('[data-kp-crossover]');
    var link = root.querySelector('[data-kp-bulk-crossover-link]');
    if (!container || !link) return;
    var data = crossoverData(root);
    if (!data.variants.length) return;

    var parsed = tierData(root, data, data.variants[0]);
    var firstTier = parsed.tiers[0];
    if (!firstTier) return;
    var heading = container.querySelector('[data-kp-crossover-heading]');
    var message = container.querySelector('[data-kp-crossover-message]');
    var standardTiers = sourceData(root);
    var standardParsed = tierData(root, standardTiers, findActiveVariant(root, standardTiers.variants));
    var largestStandard = standardParsed.tiers.length ? standardParsed.tiers[standardParsed.tiers.length - 1].units : 0;

    if (heading) {
      heading.textContent = currentUnits >= largestStandard
        ? 'At the top standard option? Compare bulk.'
        : 'Planning a larger order?';
    }
    if (message) {
      message.textContent = 'Bulk starts at ' + firstTier.label + ' and ' + money(firstTier.unitPrice, currency) + ' per ' + unitName + '.';
    }
    var url = new URL(link.getAttribute('href'), window.location.origin);
    url.searchParams.set('variant', firstTier.id);
    link.setAttribute('href', url.pathname + url.search);
  }

  function render(root, data, variant, isInteraction) {
    if (!variant) return;
    var currency = root.getAttribute('data-currency') || 'USD';
    var parsed = tierData(root, data, variant);
    var options = selectedOption(variant, data.optionNames);
    var unitName = parsed.isTablet ? 'tablet' : 'gram';
    var unitOption = parsed.isTablet ? 'Quantity' : 'Size';
    var units = numericUnit(options[unitOption]);
    var unitPrice = Number(variant.price) / units;
    var savings = parsed.baseline > 0 ? Math.max(0, (1 - unitPrice / parsed.baseline) * 100) : 0;
    var lane = root.getAttribute('data-kp-economics-lane') || 'bulk';
    var laneLabel = lane === 'standard' ? 'standard option' : 'bulk tier';

    root.querySelector('[data-kp-selected-label]').textContent = variant.title;
    root.querySelector('[data-kp-unit-price]').textContent = money(unitPrice, currency);
    root.querySelector('[data-kp-unit-label]').textContent = 'per ' + unitName + ' at the selected ' + (lane === 'standard' ? 'option' : 'tier');
    root.querySelector('[data-kp-savings]').textContent = savings > 0.05
      ? savings.toFixed(1).replace('.0', '') + '% lower per-unit cost vs the smallest ' + laneLabel
      : 'Smallest ' + laneLabel + ' — the comparison baseline';

    var body = root.querySelector('[data-kp-tier-body]');
    body.innerHTML = '';
    parsed.tiers.forEach(function (tier, index) {
      var row = document.createElement('tr');
      var selected = tier.label === options[unitOption];
      row.setAttribute('data-selected', selected ? 'true' : 'false');
      if (selected) row.setAttribute('aria-current', 'true');
      var savingLabel = index === 0 ? 'Baseline' : tier.savings.toFixed(1).replace('.0', '') + '% lower';
      if (index === parsed.tiers.length - 1) savingLabel = '<span class="kp-best-value">Best value · ' + savingLabel + '</span>';
      row.innerHTML = '<td><strong>' + tier.label + '</strong>' + (selected ? ' · Selected' : '') + '</td>' +
        '<td>' + money(tier.price, currency) + '</td>' +
        '<td>' + money(tier.unitPrice, currency) + ' / ' + unitName + '</td>' +
        '<td>' + savingLabel + '</td>';
      body.appendChild(row);
    });

    var group = root.querySelector('[data-kp-tier-group]');
    if (group) group.textContent = parsed.isTablet ? options.Strength : root.getAttribute('data-product-title');
    if (lane === 'bulk') {
      updateQuoteLinks(root.getAttribute('data-product-handle'), variant);
    } else {
      renderCrossover(root, units, unitName, currency);
    }

    if (isInteraction) {
      publish(lane === 'standard' ? 'kp_mit_variant_selected' : 'kp_bulk_tier_selected', {
        product_handle: root.getAttribute('data-product-handle'),
        variant_id: String(variant.id),
        format: root.getAttribute('data-kp-product-format') || (parsed.isTablet ? 'tablets' : 'powder'),
        tier: options[unitOption],
        strength: options.Strength || '',
        unit_price: Number((unitPrice / 100).toFixed(4)),
        savings_percent: Number(savings.toFixed(1)),
        currency: currency,
        source_surface: lane === 'standard' ? 'standard-pdp-economics' : 'bulk-pdp-economics'
      });
    }
  }

  function initTools(root) {
    var data = sourceData(root);
    if (!data.variants.length) return;
    var current = findActiveVariant(root, data.variants);
    render(root, data, current, false);
    var lane = root.getAttribute('data-kp-economics-lane') || 'bulk';
    publish(lane === 'standard' ? 'kp_mit_economics_view' : 'kp_bulk_product_view', {
      product_handle: root.getAttribute('data-product-handle'),
      variant_id: current ? String(current.id) : '',
      currency: root.getAttribute('data-currency') || 'USD'
    });

    var lastVariantId = current ? String(current.id) : '';
    document.addEventListener('action:update:pickupLocationOnVariantChange', function (event) {
      var eventVariant = event.detail && event.detail.variant;
      if (!eventVariant) return;
      var variant = data.variants.find(function (candidate) {
        return String(candidate.id) === String(eventVariant.id);
      });
      if (!variant || String(variant.id) === lastVariantId) return;
      lastVariantId = String(variant.id);
      render(root, data, variant, true);
    });

  }

  function bindQuoteTracking() {
    document.addEventListener('click', function (event) {
      var crossover = event.target.closest('[data-kp-bulk-crossover-link]');
      if (crossover) {
        publish('kp_mit_bulk_crossover_click', {
          source: 'standard-pdp-economics',
          product_handle: crossover.closest('[data-product-handle]')?.getAttribute('data-product-handle') || '',
          bulk_product_handle: crossover.getAttribute('data-kp-crossover-product') || ''
        });
        return;
      }
      var link = event.target.closest('[data-kp-bulk-quote-link]');
      if (!link) return;
      publish('kp_bulk_quote_click', {
        source: link.getAttribute('data-kp-source') || new URL(link.href).searchParams.get('source') || 'unknown',
        product_handle: new URL(link.href).searchParams.get('product') || ''
      });
    });
  }

  function initForms() {
    document.querySelectorAll('form[data-kp-tracked-form]').forEach(function (form) {
      var started = false;
      var formType = form.getAttribute('data-kp-tracked-form');
      var start = function () {
        if (started) return;
        started = true;
        publish(formType === 'bulk-quote' ? 'kp_bulk_quote_start' : 'kp_verified_review_start', {
          source: form.getAttribute('data-source') || 'direct'
        });
      };
      form.addEventListener('input', start, { once: true });
      form.addEventListener('change', start, { once: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-kp-bulk-tools], [data-kp-standard-tools]').forEach(initTools);
    bindQuoteTracking();
    initForms();
  });
})();
